import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, User } from 'lucide-react';

const FeaturedPostCard = ({ post }) => {
  return (
    <Link
      to={`/post/${post.slug}`}
      className="block group relative overflow-hidden"
      data-testid="featured-post-card"
    >
      <div className="relative h-[600px]">
        <img
          src={post.featured_image}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-12">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-white/90">
            {post.category}
          </span>
          <h2 className="text-5xl sm:text-6xl tracking-tight leading-none font-black text-white mt-4">
            {post.title}
          </h2>
          <p className="text-base sm:text-lg leading-relaxed text-white/80 mt-4 max-w-2xl">
            {post.excerpt}
          </p>
          <div className="flex items-center space-x-6 mt-6 text-sm text-white/70">
            <div className="flex items-center space-x-2">
              <User className="w-4 h-4" />
              <span>{post.author}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Clock className="w-4 h-4" />
              <span>{post.reading_time} min read</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default FeaturedPostCard;
